module.exports = __webpack_public_path__ + "img/5.84de506a.jpg";